import { render, staticRenderFns } from "./ManagerCard.vue?vue&type=template&id=4ff92c9a"
import script from "./ManagerCard.vue?vue&type=script&lang=ts"
export * from "./ManagerCard.vue?vue&type=script&lang=ts"
import style0 from "./ManagerCard.vue?vue&type=style&index=0&id=4ff92c9a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports